import { BehaviorSubject } from 'rxjs'
import { ExamDto, Horse, Person, ServiceDto, Starter } from '../../../api'

export function getDefaultScoringType(youthStatus: number | null | undefined, leisureStatus: boolean | null | undefined): number {
  const y = youthStatus ?? 0
  if (y === 2) return 4
  if (y === 1) return 3
  if (leisureStatus) return 2
  return 1
}

export interface ServiceDtoWithAmount extends ServiceDto {
  amount?: number
}

export interface RegistrationState {
  loading$: BehaviorSubject<boolean>
  activeScreen$: BehaviorSubject<number>
  selectedHorse$: BehaviorSubject<Horse | null>
  selectedRider$: BehaviorSubject<Person | null>
  selectedExams$: BehaviorSubject<ExamDto[]>
  selectedServices$: BehaviorSubject<ServiceDtoWithAmount[]>
  additionalHorses$: BehaviorSubject<Horse[]>
  additionalRiders$: BehaviorSubject<Person[]>
  selectedStarter$: BehaviorSubject<Starter | null>
  gweGateExam$: BehaviorSubject<number>
  scoringType$: BehaviorSubject<number | null>
  noChanges$: BehaviorSubject<boolean>
  originalServices$: BehaviorSubject<ServiceDtoWithAmount[]>
}

export function resetRegistrationState() {
  registrationState.activeScreen$.next(0)
  registrationState.selectedServices$.next([])
  registrationState.selectedRider$.next(null)
  registrationState.selectedHorse$.next(null)
  registrationState.selectedExams$.next([])
  registrationState.additionalHorses$.next([])
  registrationState.additionalRiders$.next([])
  registrationState.selectedStarter$.next(null)
  registrationState.gweGateExam$.next(-1)
  registrationState.scoringType$.next(null)
  registrationState.noChanges$.next(false)
  registrationState.originalServices$.next([])
}

export const registrationState: RegistrationState = {
  loading$: new BehaviorSubject<boolean>(false),
  activeScreen$: new BehaviorSubject<number>(0),
  selectedHorse$: new BehaviorSubject<Horse | null>(null),
  selectedRider$: new BehaviorSubject<Person | null>(null),
  selectedExams$: new BehaviorSubject<ExamDto[]>([]),
  selectedServices$: new BehaviorSubject<ServiceDtoWithAmount[]>([]),
  additionalHorses$: new BehaviorSubject<Horse[]>([]),
  additionalRiders$: new BehaviorSubject<Person[]>([]),
  selectedStarter$: new BehaviorSubject<Starter | null>(null),
  gweGateExam$: new BehaviorSubject<number>(-1),
  scoringType$: new BehaviorSubject<number | null>(null),
  noChanges$: new BehaviorSubject<boolean>(false),
  originalServices$: new BehaviorSubject<ServiceDtoWithAmount[]>([]),
}
